<template>
    <ul class="pagination">
        <li class="pagination-item">
            <button
                type="button"
                class="vh-button vh-button-small vh-button-outline-default"
                @click="onClickFirstPage"
                v-show="!isInFirstPage"
            >
                <i class="ti-angle-double-left"></i>
            </button>
        </li>
    
        <li class="pagination-item">
            <button
                type="button"
                class="vh-button vh-button-small vh-button-outline-default"
                @click="onClickPreviousPage"
                v-show="!isInFirstPage"
            >
                <i class="ti-angle-left"></i>
            </button>
        </li>
    
        <!-- Visible Buttons Start -->
    
        <li
            class="pagination-item"
            v-for="page in pages"
            :key="page.name"
            >
            <button
                type="button"
                class="vh-button vh-button-small"
                :class="activePage(page.name)"
                @click="onClickPage(page.name)"
            >
                {{ page.name }}
            </button>
        </li>
    
        <!-- Visible Buttons End -->
    
        <li class="pagination-item">
            <button
                type="button"
                class="vh-button vh-button-small vh-button-outline-default"
                @click="onClickNextPage"
                v-show="!isInLastPage"
            >
                <i class="ti-angle-right"></i>
            </button>
        </li>
    
        <li  class="pagination-item">
            <button
                type="button"
                class="vh-button vh-button-small vh-button-outline-default"
                @click="onClickLastPage"
                v-show="!isInLastPage"
            >
                <i class="ti-angle-double-right"></i>
            </button>
        </li>
    </ul>
  </template>
  
<script>
import { Text } from '@/utils';

export default
  {
    props:
    {
        page:
        {
            type: Object,
            required: true,
            default: () => {
                return {
                    total: 0,
                    to: 1,
                    from: 15,
                    currentPage: 1,
                    nextPage: null,
                    lastPage: 1,
                    path: null,
                    url: null,
                }
            }
        },

        maxVisibleButtons:
        {
            type: Number,
            required: false,
            default: 3
        },

        // totalPages:
        // {
        //     type: Number,
        //     required: true
        // },

        // perPage:
        // {
        //     type: Number,
        //     required: true
        // },

        // currentPage:
        // {
        //     type: Number,
        //     required: true
        // }
    },

    data()
    {
        return {
            currentPage: 1,
            totalPages: 10,
            perPage: 10,
            total: 1,
        }
    },

    created()
    {
        this.initialize();
    },

    computed:
    {
        startPage()
        {
            // When on the first page
            if (this.currentPage === 1)
            {
                return 1;
            }

            // When on the last page
            if (this.currentPage === this.totalPages)
            {
                const start = this.totalPages - (this.maxVisibleButtons - 1);

                if (start === 0) {
                    return 1;
                } else {
                    return start;
                }
            }

            // When inbetween
            return this.currentPage - 1;
        },

        endPage()
        {
            return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
        },

        pages()
        {
            const range = [];

            for (let i = this.startPage; i <= this.endPage; i+= 1 )
            {
                range.push({
                    name: i,
                    isDisabled: i === this.currentPage 
                });
            }

            return range;
        },

        isInFirstPage()
        {
            return this.currentPage === 1;
        },

        isInLastPage()
        {
            return this.currentPage === this.totalPages;
        },

        isPageActive(page)
        {
            return this.currentPage === page;
        },
    },

    methods:
    {
        onClickFirstPage()
        {
            this.currentPage = 1;
 
            this.$router.push(
                Text.formUrl(this.$route.query, this.page.url, this.currentPage)
            );
        },

        onClickPreviousPage()
        {
            if (this.currentPage != 1)
            {
                this.currentPage -= 1;

                this.$router.push(
                    Text.formUrl(this.$route.query, this.page.url, this.currentPage)
                );
            }
        },

        onClickPage(page)
        {
            this.currentPage = page;

            this.$router.push(
                Text.formUrl(this.$route.query, this.page.url, page)
            );
        },

        onClickNextPage()
        {
            this.currentPage += 1;

            this.$router.push(
                Text.formUrl(this.$route.query, this.page.url, this.currentPage)
            );
        },

        onClickLastPage()
        {
            this.currentPage = this.totalPages;

            this.$router.push(
                Text.formUrl(this.$route.query, this.page.url, this.currentPage)
            );
        },

        activePage(page)
        {
            let activeClass = 'vh-button-outline-default';

            if (page == this.currentPage)
            {
                activeClass = 'vh-button-primary';
            }

            return activeClass;
        },

        initialize()
        {
            if (Object.keys(this.$route.query).length > 0)
            {
                if (this.$route.query.page) this.currentPage = parseInt(this.page.currentPage);

                this.totalPages = this.page.lastPage;

                this.total = this.page.total;
            }
        },
    }
};
</script>

<style scoped>
    .pagination {
        list-style-type: none;
    }

    .pagination-item {
        display: inline-block;
        margin-right: 1px
    }
</style>